import type { Locale } from "@/lib/i18n";

export type ScopeIntentId =
  | "diagnostic"
  | "revenue_fix"
  | "revenue_engine"
  | "fix"
  | "improve"
  | "rebuild"
  | "ongoing";

export type ChallengeId =
  | "slow"
  | "not_converting"
  | "conversion_friction"
  | "technical_seo_visibility"
  | "measurement_data"
  | "custom_features"
  | "migrating"
  | "ongoing_help";

export interface QuoteLinkParams {
  intent?: ScopeIntentId;
  challenge?: ChallengeId;
  source?: string;
  ref?: string;
}

export function quotePath(locale: Locale): string {
  return locale === "es" ? "/es/cotizacion" : "/get-a-quote";
}

/** Build a typed search-param object for the quote route. */
export function quoteSearch(params: QuoteLinkParams): QuoteLinkParams {
  const out: QuoteLinkParams = {};
  if (params.intent) out.intent = params.intent;
  if (params.challenge) out.challenge = params.challenge;
  if (params.source) out.source = params.source;
  if (params.ref) out.ref = params.ref;
  return out;
}
